import * as api from './api';
import { Setting, Request } from '../';
import { sleep } from '@yichui/js-contrib/src/utils';

// 防并发请求
let doing_user = false; //

//
const state = {
  mallUser: {}, // 模块用户信息
  cartStoreList: [],
  totalAmount: 0, // 总价格
};

//
const mutations = {
  updateState(state, payload) {
    const keys = Object.keys(payload);
    keys.forEach(key => {
      state[key] = payload[key];
    });
  },
  SET_MALL_USER: (state, data) => {
    state.mallUser = Object.assign({}, data);
  },
};

//
const actions = {
  // 我的信息
  async mallUser({ state, commit }, params) {
    if (doing_user) {
      // 并发等结果
      while (doing_user) {
        await sleep(50);
      }
    } else {
      //
      try {
        doing_user = true;
        //
        const data = await api.mallUser(params);
        // console.log('mallUser', data);
        if (data) {
          commit('SET_MALL_USER', data);
        }
      } catch (err) {
        // 未知错误
        // console.error(`mallUser`, err);
        commit('SET_MALL_USER', {});
      } finally {
        doing_user = false;
      }
    }
    return state.mallUser;
  },
  // 购物车列表
  async getCartList({ state, commit }, params) {
    const cartStoreList = await api.queryCartList(params);
    commit('updateState', { cartStoreList });
  },
};

//
const getters = {};

//
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
